module.exports = __webpack_public_path__ + "static/media/emj08.73051656.svg";